import { cn } from "@/lib/utils";
import {
  AutoBuildButton,
  PreviewDimensionTabs,
  ReflectingIndicator,
} from "./tree/header";

export const TreeViewSidebarContent = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  return (
    <div className="flex flex-col justify-between  items-center self-stretch gap-[16px] h-full min-h-0 bg-white border-r">
      <div className="flex flex-row justify-between items-start self-stretch gap-[16px] flex-shrink-0 h-[48px] px-[16px] py-[8px] bg-white border-b">
        <PreviewDimensionTabs />
        <div className="flex flex-row items-center gap-2">
          <ReflectingIndicator />
          <AutoBuildButton />
        </div>
      </div>
      <div className="flex-1 min-h-0 w-full">{children}</div>
    </div>
  );
};

export const TreeViewSidebarLayout = ({
  children,
  className,
}: {
  children: React.ReactNode;
  className?: string;
}) => {
  return (
    <div
      className={cn(
        "w-[500px] rounded-l-lg flex flex-col gap-[16px] items-center !bg-[#FAFAFA] h-full",
        className,
      )}
    >
      {children}
    </div>
  );
};
